import { render, staticRenderFns } from "./QuizEvent.vue?vue&type=template&id=3f9ce492&"
import script from "./QuizEvent.vue?vue&type=script&lang=js&"
export * from "./QuizEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports